<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Tags"><app-manage-tags></app-manage-tags></mat-tab>
</mat-tab-group>
